<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-03-31 17:24:33
 * @Description: file content
-->
<template>
  <div>
    <Select v-model:value="state.value" show-search :placeholder="$lang('请输入')" :default-active-first-option="false"
    :show-arrow="true" :filter-option="false" :options="state.data" @search="handleSearch" @change="handleChange"
    v-bind="{ ...props.bind }">
    <template v-if="state.fetching" #notFoundContent>
      <Spin size="small" />
    </template>
  </Select>
  </div>
</template>
<script lang="ts" setup>
import { reactive, nextTick, watch } from 'vue'
import { Select, Spin } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import { useApi } from '@xinghai/site-common'
import { lang } from '@/utils'
type Props = {
  value: string | Array<any> | undefined
  /**接口url */
  ajaxUrl: any
  /**入参的名字 */
  queryKey: string
  labelKey?: string
  valueKey?: string
  query: any
  format?: (item: any) => any
  // 是否默认请求数据
  defaultFetch?: boolean
  hasAll?: boolean
  bind?: any
}
const props = withDefaults(defineProps<Props>(), {
  queryKey: 'name',
  labelKey: 'label',
  valueKey: 'value',
  defaultFetch: false,
  hasAll: false,
  query: {},
  bind: {}
})
const box_list = useApi(props.ajaxUrl)
/**单选 */
const state = reactive({
  data: [],
  value: props.value,
  fetching: false
})
const emit = defineEmits(['update:value', 'changeObj'])

const getData = (val: string) => {
  state.fetching = true
  box_list
    .fetchData({ ...props.query, [props['queryKey']]: val.trim() })
    .then((res) => {
      const data = res.data?.records || res.data || []
      if (props.hasAll) {
        data.unshift({
          [props.labelKey]: lang('全部'),
          [props.valueKey]: '',
          label: lang('全部'),
          value: ''
        })
      }
      if (props.format) {
        state.data = props.format(data)
      } else {
        state.data = data.map((_: any) => {
          return {
            ..._,
            label: _[props.labelKey],
            value: _[props.valueKey]
          }
        })
      }
      // sort((a: { label: string }, b: { label: any }) => {
      //   return a.label.localeCompare(b.label)
      // })
      console.log(state.data)
    })
    .finally(() => {
      state.fetching = false
    })
}
const handleSearch = debounce((val: string) => {
  if (props.defaultFetch || !val.trim()) return
  getData(val)
}, 300)

if (props.defaultFetch) {
  const val = (props.value || '') as string
  getData(val)
}

/**多选 */
watch(
  () => props.value,
  (c) => {
    state.value = c
  }
)
/**导出一个exportObj，包含选中当前行的所有数据 */
const handleChange = (val?: any) => {
  // value.value = val
  const item = state.data.find((_: any) => _.value === val)
  // emit('update:value', val)
  emit('update:value', val)
  nextTick(() => {
    emit('changeObj', item)
  })
}
defineExpose({ handleSearch })
</script>
<style lang="less" scoped></style>
